<script lang='ts'>
    import { suggestions } from '../store/suggestions';
    import { onMount } from 'svelte';
    import { getSuggestions } from '../actions/getSuggestions';
    import Suggestion from './Suggestion.svelte';

    onMount(() => {
        getSuggestions();
    })
</script>

<h2>Manage Suggestions</h2>
<ul>
    {#each $suggestions as suggestion}
        <Suggestion suggestion={suggestion.suggestion} id={suggestion.id} />
    {/each}
</ul>
